import React, { useState } from "react";
import { Oval } from "react-loader-spinner";
import { Link, useNavigate, useLocation } from "react-router-dom";
import BGShutterstock from "images/auth/bg-shutterstock.png";
import { ReactComponent as TVendorIcon } from "images/auth/t-vendors.svg";
import useLogout from "hooks/useLogout";
import { useTranslation } from "react-i18next";
import { useAppContext } from "hooks/useContext";
import { STATUS_ACTIVE, SUBSTATUS_READY_FOR_WORK } from "utils/constantValues";

function BurgerMenu({ isNavOpen, setIsNavOpen, routePages = [] }) {
  return (
    <nav className="hidden md-max:block">
      <section className="flex">
        <div
          className="space-y-2 cursor-pointer"
          onClick={() => setIsNavOpen((prev) => !prev)}
        >
          <span className="block h-0.5 w-8 animate-pulse bg-white"></span>
          <span className="block h-0.5 w-8 animate-pulse bg-white"></span>
          <span className="block h-0.5 w-8 animate-pulse bg-white"></span>
        </div>

        <div className={isNavOpen ? "showMenuNav" : "hideMenuNav"}>
          <div
            className="absolute top-[10px] right-0 p-[1rem]"
            onClick={() => setIsNavOpen(false)}
          >
            <svg
              className="h-8 w-8 text-gray-900"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </div>
          <div className="flex flex-col items-center justify-center gap-[10px] content-center h-full">
            {routePages.map((path) => {
              return (
                <Link
                  key={path.url}
                  className="border-b border-base-black my-[5px] uppercase  text-[16px] not-italic font-regular"
                  to={path.url}
                >
                  {path.title}
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </nav>
  );
}

function Header() {
  const { userDetails } = useAppContext();

  const isShowTeamPage =
    userDetails?.agencyId &&
    STATUS_ACTIVE === userDetails?.status &&
    SUBSTATUS_READY_FOR_WORK === userDetails?.subStatus;

  const [t] = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { onLogoutSubmit, isLoading } = useLogout();
  const [isNavOpen, setIsNavOpen] = useState(false);
  const routePages = [
    { url: "/", title: t("Profile"), show: true },
    { url: "/teams", title: t("Teams"), show: isShowTeamPage },
  ].filter((item) => item.show);

  return (
    <div
      className="w-full h-[80px] bg-no-repeat  bg-cover bg-center flex items-center justify-between px-[80px] md-max:px-[1rem]"
      style={{
        backgroundImage: `url(${BGShutterstock})`,
      }}
    >
      <div className="flex gap-[30px] items-center h-full">
        <TVendorIcon onClick={() => navigate("/")} className="cursor-pointer" />

        {routePages.length > 1 && (
          <nav className="flex items-center gap-[10px] md-max:hidden">
            {routePages.map((path) => {
              const isActive = location.pathname === path.url;
              return (
                <Link
                  key={path.url}
                  to={path.url}
                  title={path.title}
                  className={`relative text-[20px] not-italic cursor-pointer py-[10px] px-[15px] transition-all duration-300 ease-in-out  mt-[10px] ${
                    isActive
                      ? "text-secondary font-bold p-[10px]  underline"
                      : "text-white font-medium underline"
                  }`}
                >
                  {path.title}
                  {isActive && (
                    <span className="absolute -bottom-[2px] left-0 w-full h-[3px] bg-secondary transition-width duration-300 ease-in-out"></span>
                  )}
                </Link>
              );
            })}
          </nav>
        )}
      </div>
      <div className="flex items-center gap-[10px]">
        <button
          className="flex py-[14px] bg-transparent h-[40px] px-[16px] items-center justify-center gap-[8px] rounded-[6px] border-[1px] border-solid border-white cursor-pointer"
          type="button"
          onClick={onLogoutSubmit}
          disabled={isLoading}
        >
          <Oval
            height={30}
            width={30}
            color="#fff"
            visible={isLoading}
            ariaLabel="oval-loading"
            secondaryColor="#fff"
            strokeWidth={5}
            strokeWidthSecondary={3}
          />
          <div className="text-white font-bold text-[16px] not-italic">
            {t("Logout")}
          </div>
        </button>
        {routePages.length > 1 && (
          <BurgerMenu
            isNavOpen={isNavOpen}
            setIsNavOpen={setIsNavOpen}
            routePages={routePages}
          />
        )}
      </div>
    </div>
  );
}

export default Header;
